import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const deleteTenantLanguage = (token, id) => {
    return fetch(`${apiUrl}tenant_languages/${id}`, {
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export default deleteTenantLanguage